import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Observable, Subscription, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ZuperSdkRequestService {
  private defaultTimeout = 10000; // Default timeout in milliseconds
  private defaultHeaders = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'Content-Type': 'application/json'
  };

  constructor(private http: HttpClient) { }

  request(data: any): Observable<any> {
    // Merge provided options with defaults
    const options = data.message.options;
    const requestOptions = {
      timeout: this.defaultTimeout,
      headers: this.defaultHeaders,
      contentType: 'application/json',
      cors: false,
      externalRequest: true,
      ...options
    };

    if(!requestOptions.externalRequest){
      if(requestOptions.url.includes('http')){
        return throwError('Invalid URL');
      }else{
        requestOptions.url = `${localStorage.getItem('dc_api_url')}/api${requestOptions.url}`;
      }
    }

    // Construct HTTP headers
    const headers = new HttpHeaders(requestOptions.headers || {});

    // Construct HTTP options
    const httpOptions = {
      headers: headers,
      params: requestOptions.params || [],
      responseType: 'text' as const, // Adjust as per response type needed (json, text, etc.)
      observe: 'response' as const, // Adjust as per observation needed (response, body, etc.)
      withCredentials: requestOptions.cors,
      body: requestOptions.data || {}
    };

    // Make the HTTP request

    switch (requestOptions.type.toUpperCase()) {
      case 'GET':
        return this.http.get(requestOptions.url, httpOptions).pipe(
          catchError(this.handleError)
        );
      case 'POST':
        return this.http.post(requestOptions.url, requestOptions.data, httpOptions).pipe(
          catchError(this.handleError)
        );
      case 'PUT':
        return this.http.put(requestOptions.url, requestOptions.data, httpOptions).pipe(
          catchError(this.handleError)
        );
      case 'DELETE':
        return this.http.delete(requestOptions.url, httpOptions).pipe(
          catchError(this.handleError)
        );
      case 'PATCH':
        return this.http.patch(requestOptions.url, requestOptions.data, httpOptions).pipe(
          catchError(this.handleError)
        );
      default:
        return throwError(`Unsupported HTTP method: ${requestOptions.type}`);
    }
  }

  private handleError(error: any): Observable<never> {
    return throwError(error);
  }
}
